<!-- Admin Settings - Two Panel Layout -->
<div class="admin-settings-container">
  
  <!-- Page Header -->
  <div class="page-header bg-white border-bottom shadow-sm mb-4 sticky-top">
    <div class="container-fluid py-3">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h1 class="h3 mb-0 text-gray-800">
            <i class="fa fa-cog me-2 text-primary"></i>
            Admin Settings
          </h1>
          <p class="text-muted mb-0">Configure application settings and preferences</p>
        </div>
        <div class="d-flex gap-2">
          <button type="button" 
                  class="btn btn-outline-primary btn-sm"
                  (click)="refreshSettings()"
                  [disabled]="isLoading">
            <i class="fa" 
               [class.fa-sync]="!isLoading" 
               [class.fa-spinner]="isLoading" 
               [class.fa-spin]="isLoading" 
               class="me-1"></i>
            {{ isLoading ? 'Loading...' : 'Refresh' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content Panel -->
  <div class="container-fluid pb-4">
    <div class="row g-4">
      
      <!-- Left Navigation Panel -->



      <div id="settings-navigation" class="col-12 col-lg-3 p-3">
        <div class="card border-0 shadow-sm">
          <div class="card-header bg-primary bg-gradient text-white">
            <h4 class="card-title mb-0">
              <i class="fa fa-bars me-2"></i>
              Settings Categories
            </h4>
          </div>

          <!-- Navigation Links -->
          <div id="setting-nav-container" class="card-body p-0">
            <app-settings-nav 
              [activePanel]="activePanel" 
              (panelChange)="setActivePanel($event)">
            </app-settings-nav>
          </div>

        </div>
      </div>

      <!-- Right Content Panel -->
      <div class="col-12 col-lg-9">
        
        <!-- General Settings Panel -->
         <app-settings-general-info-form *ngIf="activePanel === 'general'">
        </app-settings-general-info-form>

        <!-- Email Configuration Panel -->
        <app-settings-email-config-form *ngIf="activePanel === 'email'">
        </app-settings-email-config-form>

        <!-- Course Management Panel -->
        <app-settings-course-manage-form *ngIf="activePanel === 'courses'">
        </app-settings-course-manage-form>

        <!-- Security Settings Panel -->
        <app-settings-security-form *ngIf="activePanel === 'security'">
        </app-settings-security-form>

        <!-- Maintenance Panel -->
         <app-settings-maintenance-form *ngIf="activePanel === 'maintenance'">
        </app-settings-maintenance-form>

      </div>
    </div>
  </div>

  <!-- Loading State -->
  <div class="container-fluid pb-4 text-center" *ngIf="isLoading">
    <div class="card border-0 shadow-sm">
      <div class="card-body p-5">
        <div class="spinner-border text-primary mb-3" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <h5 class="text-muted">Loading Settings...</h5>
        <p class="text-muted mb-0">Please wait while we fetch the configuration data.</p>
      </div>
    </div>
  </div>

</div>

